var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header bg-transparent"},[_c('div',[_c('h3',{staticClass:"mb-0"},[_vm._v("\n                    "+_vm._s(_vm.$t('message.fileManager'))+"\n                ")])])]),_c('div',{staticClass:"card-body"},[_c('file-manager',{attrs:{"settings":_vm.settings}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }